export const variablesBySessionStorage = (type, name, data = false) => {
  switch (type) {
    case 'SET':
      const savingData = JSON.stringify(data);
      sessionStorage.setItem(name, savingData);
      break;
    case 'GET':
      const dataParse = sessionStorage.getItem(name);
      return JSON.parse(dataParse);
    case 'REMOVE':
      sessionStorage.removeItem(name);
      break;
    case 'CLEAR':
      sessionStorage.clear();
      break;
    default:
      break;
  }
};
